import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { HtmlInclude } from '../components/common/html-include/HtmlInclude';
import { useEffect } from 'react';
import { loadFeefoScript } from '../util/ReviewUtil';
export const useFeefoWidget = (productCode, shouldLoad) => {
    const { review: { feefoIdentifier }, } = useAemConfig();
    const renderFeefoWidget = () => (_jsx(HtmlInclude, { htmlFragment: `<div id="feefo-product-review-widgetId" class="feefo-review-widget-product" data-parent-product-sku="${productCode}"></div>` }));
    useEffect(() => {
        if (shouldLoad && feefoIdentifier) {
            loadFeefoScript(feefoIdentifier);
        }
    }, [shouldLoad]);
    return {
        renderFeefoWidget,
    };
};
